module.exports = require("rc-calendar/lib/RangeCalendar");


//////////////////
// WEBPACK FOOTER
// external "rc-calendar/lib/RangeCalendar"
// module id = 129
// module chunks = 0